import { render, staticRenderFns } from "./site-footer.vue?vue&type=template&id=f382a6e2&"
import script from "./site-footer.vue?vue&type=script&lang=ts&"
export * from "./site-footer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports